<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="8.522" height="8.523" viewBox="0 0 8.522 8.523">
		<g id="Group_44567" data-name="Group 44567" transform="translate(0 0)">
			<g id="Group_30579" data-name="Group 30579">
				<path
					id="Path_21072"
					data-name="Path 21072"
					d="M4.255,8.523H1.3c-.116,0-.232,0-.348,0a.917.917,0,0,1-.8-.5A1.158,1.158,0,0,1,0,7.429Q0,6.45,0,5.47T0,3.495Q0,2.3,0,1.11A1.12,1.12,0,0,1,.379.218.86.86,0,0,1,.955,0C1.6,0,2.237,0,2.878,0h.53a.424.424,0,0,1,.4.285.42.42,0,0,1-.385.564c-.405,0-.811,0-1.216,0-.35,0-.7,0-1.05,0a.277.277,0,0,0-.3.306c0,.191,0,.381,0,.572V3.778q0,1.037,0,2.074c0,.5,0,.994,0,1.491A.513.513,0,0,0,.879,7.5a.244.244,0,0,0,.247.169H5.3c.688,0,1.375,0,2.063,0a.28.28,0,0,0,.3-.306c0-.263,0-.527,0-.79,0-.484.005-.967,0-1.45a.428.428,0,1,1,.855,0c0,.322,0,.644,0,.966q0,.658,0,1.315a1.168,1.168,0,0,1-.254.772.88.88,0,0,1-.7.343c-.554,0-1.109,0-1.663,0H4.255Z"
					transform="translate(0 -0.001)"
					fill="#262626"
				/>
				<path
					id="Path_21073"
					data-name="Path 21073"
					d="M11.231,1.537c-.012.011-.026.022-.037.033L9.044,3.719q-.45.45-.9.9a.457.457,0,0,1-.447.132A.439.439,0,0,1,7.348,4.4a.454.454,0,0,1,.129-.439q.311-.31.621-.621L9.188,2.249,10.536.9l.038-.044c-.031,0-.05-.005-.07-.005-.317,0-.634-.005-.951,0A.432.432,0,0,1,9.128.528a.418.418,0,0,1,.266-.5A.423.423,0,0,1,9.541,0c.569,0,1.137,0,1.7,0,.139,0,.277,0,.416,0a.42.42,0,0,1,.407.277.42.42,0,0,1,.03.157q0,1.055,0,2.11a.428.428,0,0,1-.283.413.421.421,0,0,1-.568-.376c-.006-.327,0-.655,0-.982V1.544l-.015-.007"
					transform="translate(-3.578 0)"
					fill="#262626"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ExpandSvg',
};
</script>

<style scoped lang="scss"></style>
